module.exports = __webpack_public_path__ + "static/deploy-99060084bccc8677f0b6487bfb16ef22.png";